import { useL10n } from '@uplift/hooks';
import { useLanguagesQuery } from '@uplift/queries';
import { SearchListContained } from '@uplift/ui-v2';

export type SpokenLanguagesFormProps = {
  hideLabel?: boolean;
};

export const SpokenLanguagesForm: React.VFC<SpokenLanguagesFormProps> = props => {
  const { data: languages = [], isInitialLoading: loading } = useLanguagesQuery();
  const l10n = useL10n();

  return (
    <div style={{ height: '100%' }}>
      <SearchListContained
        name="spokenLanguages"
        label={!props.hideLabel && 'Select any other languages you use for sessions (Optional)'}
        options={languages}
        loading={loading}
        getOptionLabel={(option) => option.name}
        placeholder="Search for languages"
        selectionOverviewText="languages selected"
        optionVariant="checkbox"
        emptyMessage={<>Can’t find a language? Email us at <b>{l10n.helpEmail}</b> with the language you’re looking for.</>}
        fullPageMobileView={true}
      />
    </div>
  );
};
